module.exports = __webpack_public_path__ + "img/person-recommendations.843b4d19.svg";